import React from "react";
import { styled } from "@material-ui/core/styles";
import { brand } from "../StyledComponents/theme";

const StatWrapper = styled("div")({
  display: "flex",
  border: `1px solid ${brand.divider}`,
  overflow: "hidden",
  alignItems: "center",
  borderRadius: 12,
  backgroundColor: "#fff",
  boxShadow: brand.cardShadow,
  transition: "box-shadow 200ms ease, transform 200ms ease",
  "&:hover": {
    boxShadow: brand.cardShadowHover,
    transform: "translateY(-2px)",
  },
});

const StatLabel = styled("div")({
  background: brand.navyGradient,
  justifyContent: "center",
  display: "flex",
  alignItems: "center",
  padding: "22px 0",
  fontSize: "22px",
  color: "#fff",
  flexBasis: "140px",
  flexShrink: 0,
  fontWeight: 600,
  letterSpacing: "0.3px",
});

const StatCaption = styled("div")({
  padding: "18px 20px",
  fontSize: "16px",
  color: brand.textHigh,
  flexGrow: 1,
  textAlign: "left",
  letterSpacing: "0.2px",
  display: "flex",
  alignItems: "center",
});

/**
 * Gradient-labelled stat row (the HR dashboard "story flow" style).
 */
const StatCard = ({ value, caption }) => (
  <StatWrapper>
    <StatLabel>{value}</StatLabel>
    <StatCaption>{caption}</StatCaption>
  </StatWrapper>
);

export default StatCard;
